// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app.en .section[data-v-0160b001].down-first {\n  min-width: 322px;\n}\n#app.en .section[data-v-0160b001].down-two {\n  min-width: 398px;\n}\n#app.en .section[data-v-0160b001].down-three {\n  min-width: 334px;\n}\n#app.en .section[data-v-0160b001].down-four {\n  min-width: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
